module.exports = __webpack_public_path__ + "static/img/抖音广告_05.c2cc882.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/gdd102/抖音广告_05.jpg
// module id = ng9b
// module chunks = 1